import { ProcedureSchema } from "@redotech/redo-model/markdown-flow";
import * as z from "zod/v4";

export const getProcedure = {
  name: "getProcedure" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ procedure: ProcedureSchema.nullable() }),
};
